import { useEffect, useRef, useState } from "react";
import { Headphones, Pause, Play, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { markActive } from "@/lib/seatTime";
import { useProfile } from "@/context/ProfileContext";

export const NarrationButton = ({ text }) => {
  const [state, setState] = useState("idle");
  const { buddy } = useProfile();
  const who = buddy?.name || "Aria";
  const audio = useRef(null);
  const url = useRef(null);

  useEffect(() => () => {
    audio.current?.pause();
    if (url.current) URL.revokeObjectURL(url.current);
  }, []);

  useEffect(() => {
    audio.current?.pause();
    audio.current = null;
    setState("idle");
  }, [text]);

  const toggle = async () => {
    if (state === "playing") { audio.current.pause(); return setState("paused"); }
    if (state === "paused") { await audio.current.play(); return setState("playing"); }
    setState("loading");
    try {
      const r = await http.post("/tts", { text, voice: buddy?.voice }, { responseType: "blob" });
      if (url.current) URL.revokeObjectURL(url.current);
      url.current = URL.createObjectURL(r.data);
      const a = new Audio(url.current);
      a.ontimeupdate = markActive;
      a.onended = () => setState("idle");
      audio.current = a;
      await a.play();
      setState("playing");
    } catch {
      toast.error(`${who}'s voice is unavailable right now.`);
      setState("idle");
    }
  };

  const Icon = state === "loading" ? Loader2 : state === "playing" ? Pause : state === "paused" ? Play : Headphones;
  const label = { idle: `Listen with ${who}`, loading: "Preparing voice…", playing: "Pause", paused: "Resume" }[state];
  return (
    <button onClick={toggle} disabled={state === "loading"} data-testid="lesson-narrate-btn" data-state={state}
      className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#E3EBE5] text-[#2C4A3E] hover:bg-[#d5e2d9] disabled:opacity-70 transition-colors">
      <Icon className={`w-4 h-4 ${state === "loading" ? "animate-spin" : ""}`} /> {label}
    </button>
  );
};
